module.exports = __webpack_public_path__ + "static/register-25e59d0f5951bf871b34bad748efa0d2.png";